import * as React from 'react';
import { AdminItemCardButtons } from 'components';
import { IItemCardProps, IAdminItemCardButtonsProps } from 'models/itemcard';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IArticleTagDomainValue } from 'models/magazine/article/articletagdomainvalue';
interface IProps extends IItemCardProps {
	item: IArticleTagDomainValue;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminTagItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.deleteItem = this.deleteItem.bind(this);
	}

	public deleteItem(e: any) {
		e.stopPropagation();
		if (this.props.deleteItem) {
			this.props.deleteItem(null, this.props.item.key.toString());
		}
	}

	public render() {
		const { currentUserIsAdministrator } = this.props;
		const { value } = this.props.item;

		const adminItemCardButtonsProps: IAdminItemCardButtonsProps = {
			deleteItem: this.props.deleteItem !== undefined && currentUserIsAdministrator ? this.deleteItem : null,
		};

		return (
			<div className="adminItemCard adminTagItemCard">
				<div className="innerHolder">
					<div className="buttonsHolder">
						<AdminItemCardButtons {...adminItemCardButtonsProps} />
					</div>
					<div className="left">
						<div className="title">
							<span>{value}</span>
						</div>
					</div>
					<div className="right" />
					<div className="clear" />
				</div>
			</div>
		);
	}
}

export { AdminTagItemCard };
